"use strict";
import Account from "../../api/account";
import loadDocumentRelationshipService from "../../services/load_document_relationship_service";
export function fetchDocumentLoadRelationships(documentIds, loadStateIds, callback) {
  if (!Account.current().payables_account) {
    return;
  }
  if (!Account.currentSettings().pod_requires_bol_validation) {
    return;
  }
  loadDocumentRelationshipService.getRelationshipData(documentIds, loadStateIds).then((relationships) => {
    callback(relationships);
  }).catch((error) => {
    console.error("Error fetching document load relationships:", error);
  });
}
